"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSourceTypesArray = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const ObjectWithHistory_1 = require("../../utils/objects/ObjectWithHistory");
const ServiceLocator_1 = __importDefault(require("../../utils/ServiceLocator"));
exports.dataSourceTypesArray = [
    'none',
    'other',
    'gtfs',
    'odTrips',
    'transitSmartCardData',
    'transitOperationalData',
    'taxiTransactions',
    'carSharingTransactions',
    'bikeSharingTransactions',
    'gpsTraces',
    'streetSegmentSpeeds',
    'zones',
    'osmData',
    'places',
    'propertyRegistry'
];
class DataSource extends ObjectWithHistory_1.ObjectWithHistory {
    constructor(attributes = {}, isNew, collectionManager) {
        super(attributes, isNew);
        this._collectionManager = collectionManager ? collectionManager : ServiceLocator_1.default.collectionManager;
    }
    toString() {
        return this.attributes.name || this.attributes.shortname || this.getId();
    }
    get collectionManager() {
        // TODO: test or use dependency injection
        return this._collectionManager;
    }
    static getPluralName() {
        return 'dataSources';
    }
    static getCapitalizedPluralName() {
        return 'DataSources';
    }
    static getDisplayName() {
        return DataSource.displayName;
    }
}
DataSource.displayName = 'DataSource';
exports.default = DataSource;
//# sourceMappingURL=DataSource.js.map